import { IMAGE_ENTITY } from './images.gql';

export const AI_PROMPT_PRESET = `
  ${IMAGE_ENTITY}
  fragment AiPromptPreset on AiPromptPreset {
    label
    prompt
    aspect_ratio
    medias(pagination: { limit: 25 }) {
      data {
        ...ImageEntity
      }
    }
  }
`;

export const AI_PROMPT_PRESET_ENTITY = `
  ${AI_PROMPT_PRESET}
  fragment AiPromptPresetEntity on AiPromptPresetEntity {
    id
    attributes {
      ...AiPromptPreset
    }
  }
`;
